import uuid from '@huaying/hy-vue-common/src/utils/uuid'
import { getFileExtension, isImageExt } from '@/utils/qiniu'
import config from '@/config'

export default {
  props: {
    accept: {
      type: String,
      default: 'image/*'
    },
    prefix: {
      type: String,
      required: true
    },
    value: {
      type: [String, Array]
    },
    api: {
      type: String,
      default: 'fw'
    }
  },
  data: () => ({
    dataObj: {
      token: '',
      key: '',
      ext: ''
    },
    uploadQiniuDomain: 'https://upload.qiniu.com',
    qiniuHost: '',
    filePreviewUrl: process.env.FILE_PREVIEW_URL
  }),
  watch: {
    value (val, oldValue) {
      if (val === oldValue) {
        return
      }

      const res = this.transformValue(val)
      if (Array.isArray(res)) {
        this.fileList = res
      } else {
        this.imageUrl = res
      }
    }
  },
  methods: {
    transformValue (val) {
      if (val && Array.isArray(val)) {
        return val.map((key, index) => {
          const names = key.split('/')
          const name = names[names.length - 1]

          return {
            name,
            qiniuKey: key,
            url: this.getFileUrlFromKey(key),
            index
          }
        })
      } else if (typeof val === 'string') {
        return val ? this.qiniuKeyToImageUrl(val) : ''
      }

      return val
    },
    getQiniuToken () {
      // fixme @wilson use common token,host
      const { getQiniuToken } = this.$api.config

      return getQiniuToken().then((res) => {
        let { host, token, uploadDomain } = res
        // 服务器中只有飞鲸的七牛域名（无法获得缤果的），如果有传参进来，直接使用这个传进来的七牛域名。
        if (this.api === 'lt') {
          host = config.LOTTERY_QINIU_URL
        } else if (this.api === 'art') {
          host = config.ARTICLE_QINIU_URL
        }
        if (uploadDomain) {
          this.uploadQiniuDomain = uploadDomain
        }

        console.log('uploadDomain:', uploadDomain)
        const qiniuHost = host.endsWith('/') ? host : `${host}/`
        console.log(qiniuHost)
        this.qiniuHost = qiniuHost
        this.dataObj.token = token

        return {
          host: qiniuHost,
          token
        }
      })
    },
    qiniuKeyToImageUrl (key) {
      return `${this.qiniuHost}${key}`
    },
    getFileUrlFromKey (key) {
      if (isImageExt(getFileExtension(key))) {
        return this.qiniuKeyToImageUrl(key)
      } else {
        return this.filePreviewUrl
      }
    },
    getFilePreviewPath (key) {
      if (isImageExt(getFileExtension(key))) {
        return key
      } else {
        return this.filePreviewUrl
      }
    },
    beforeUpload (file) {
      const ext = getFileExtension(file.name)
      const name = file.name.slice(0, file.name.indexOf(ext) - 1)

      return this.getQiniuToken().then((res) => {
        let { host, token } = res
        if (this.api === 'lt') {
          host = config.LOTTERY_QINIU_URL
          token = config.LOTTERY_QINIU_TOKEN
        } else if (this.api === 'art') {
          host = config.ARTICLE_QINIU_URL
          token = config.ARTICLE_QINIU_TOKEN
        }
        console.log('upload host:', host)
        this.qiniuHost = host.endsWith('/') ? host : `${host}/`
        this.dataObj.token = token
        this.dataObj.key = `${this.prefix}/${name}-${uuid()}.${ext}`
        this.dataObj.ext = ext
        return true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/uploadMixin.js